module.exports = __webpack_public_path__ + "static/media/declinedRequestIcon.5f62e886.svg";